export default __webpack_public_path__ + "static/media/crowdstrike.05776370.png";